<!-- src/components/EmojiPicker.vue -->
<template>
  <div ref="wrapper"></div>
</template>

<script>
import 'emoji-picker-element'

export default {
  name: 'EmojiPicker',
  emits: ['emoji-click'],
  mounted() {
    // Tạo và mount emoji-picker element
    const picker = document.createElement('emoji-picker')

    picker.classList.add('light') // hoặc 'dark' nếu cần
    picker.addEventListener('emoji-click', (event) => {
      this.$emit('emoji-click', event)
    })

    this.$refs.wrapper.appendChild(picker)
  }
}
</script>

<style scoped>
/* Optional: custom styling nếu cần */
</style>
